import React, { useEffect, useLayoutEffect, useState, useRef } from 'react'
import { Box, Container } from '../../ui/acro'
import { Tab } from 'ui/bend'
import {
  MyPracticeBox,
  StyledTab,
  Title,
  Subtitle,
  popUpStyle
} from './common/MyPracticeStyles'
import MySeries from './common/MySeries'
import PopUpModal from 'components_v2/Timeline/common/PopUpModal'
import AloMovesAnimation from 'components_v2/Search/common/AloMovesAnimation'
import { mapDataClasses } from './common/Data/rowsClasses'
import ClassesComponent from './common/Components/ClassesComponent'
import CompletedClasses from './common/Components/CompletedClasses'
import { axios } from '../../api'
import { MyPracticeDetailsProvider } from './context/MyPracticeProvider'
import NotFoundPage from 'components_v2/NotFound/NotFoundPage'
import Bundles from './common/Bundles'
import { change_practice_tab_event } from 'gtm/pushEvents'
import { connect } from 'react-redux'
import { getRequestObject } from './MyPracticeFilterHelperMethods'
// Redux
import { clearAllFilters } from '../../../javascript/redux/actions/planEntries'
import MyPlaylists from './common/MyPlaylists'
import { mapDataCompleted } from './common/Data/rowsCompletedClasses'
import { ElapsedTimeSince } from './common/ElapsedTimeSince'
import CoachmarkRenderer from 'components_v1/CoachMarkRenderer'
import { useUserContext } from 'context'

const MyPractice = ({ selected_tab, ...props }) => {
  const { user } = useUserContext()
  const createdAt = user?.createdAt
  const username = user?.username
  const showDurationSort =
    props.filteredAttributes?.type?.length === 1 &&
    props.filteredAttributes?.type[0]?.type === 'classes'

  const [selectedOptions, setSelectedOptions] = useState({
    sorting: 'desc',
    selectedColumn: 'date'
  })

  const [previousSelectedOptions, setPreviousSelectedOptions] = useState({
    sorting: 'desc',
    selectedColumn: 'date'
  })

  const [selectedClassesOptions, setSelectedClassesOptions] = useState({
    sorting: 'desc',
    selectedColumn: 'date'
  })

  const [previousSelectedClassesOptions, setPreviousSelectedClassesOptions] =
    useState({
      sorting: 'desc',
      selectedColumn: 'date'
    })

  const [days, setDays] = useState('30')
  const [previousDays, setPreviousDays] = useState('30')

  const [userSeries, setUserSeries] = useState({})
  const [userBundles, setUserBundles] = useState([])
  const [userClasses, setUserClasses] = useState([])
  const [userCompletedClasses, setUserCompletedClasses] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [url, setUrl] = useState('')
  const [copy, setCopy] = useState('')
  const [perPage, setPerPage] = useState(15)
  const [perPageClasses, setPerPageClasses] = useState(15)
  const [perPageSeries, setPerPageSeries] = useState(15)
  const [perPageBundles, setPerPageBundles] = useState(15)
  const [page, setPage] = useState(1)
  const [classesPage, setClassesPage] = useState(1)
  const [seriesPage, setSeriesPage] = useState(1)
  const [bundlesPage, setBundlesPage] = useState(1)
  const totalClasses = useRef(0)
  const totalSeries = useRef(0)
  const totalBundles = useRef(0)
  const sortOption = useRef('')
  const sortPreviousOption = useRef('')
  const daysSelected = useRef('30')
  const hasItems = useRef(true)
  const apiCalls = useRef(true)
  const bundleError = useRef(false)
  const resetDataApi = useRef(false)
  const tabClicked = useRef(false)
  const [currentTab, setCurrentTab] = useState(selected_tab)
  const [completedSummary, setCompletedSummary] = useState(null)
  const [first, setFirst] = useState(false)
  useEffect(() => {
    setCurrentTab(selected_tab)
  }, [selected_tab])

  useEffect(() => {
    const handleLocationChange = () => {
      const params = new URLSearchParams(window.location.search).toString()
      const arr = params?.split('=')
      if (
        arr?.length === 2 &&
        arr[0] === 'tab' &&
        ['playlists', 'classes', 'completed', 'series'].includes(arr[1])
      ) {
        const idMap = {
          series: 'Series',
          classes: 'Classes',
          completed: 'Completed',
          playlists: 'My Playlists'
        }
        document
          .getElementById(`tab-my_practice_tabs-${idMap[arr[1]]}`)
          ?.click()
      }
    }
    window.addEventListener('popstate', handleLocationChange)
    return () => window.removeEventListener('popstate', handleLocationChange)
  }, [])

  const [error, setError] = useState(false)

  const getSortParamName = (value) => {
    let paramName = ''
    switch (value) {
      case 'date':
        paramName = 'recentlyAdded'
        break
      case 'oldest':
        paramName = 'oldest'
        break
      case 'series':
        paramName = 'az'
        break
      case 'style':
        paramName = 'style'
        break
      case 'instructor':
        paramName = 'instructor'
        break
      default:
        paramName = value
    }
    return paramName
  }

  const seriesOptionChange = (selected) => {
    if (currentTab === 'series') {
      const selectedOptionName = getSortParamName(selected)
      sortOption.current = selectedOptionName
      // sortOption.current = selected
      const params = { selectedColumn: sortOption, days: null, page: 1 }
      fetchMyPracticeData(params, 'series')
    }
  }

  const copyToClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setCopy('SUCCESSFULLY COPIED URL')
    } catch (err) {
      setCopy('Failed to copy!')
    }
  }

  const fetchBundlesData = async (params) =>
    await axios.get('/product_subscriptions', { params })

  const getMyBundles = async (dataParams, tab) => {
    setIsLoading(true)
    try {
      const params = {
        page: dataParams.page ? dataParams.page : 1,
        per_page: dataParams.perPage ? dataParams.perPage : perPageBundles,
        type: tab
      }
      const res = await fetchBundlesData(params)
      if (res.status === 200) {
        let newUserBundles = new Array()

        newUserBundles = res.data.productSubscriptions.filter(
          (result) => result.product.type === 'Bundle'
        )

        totalBundles.current = res.data.totalCount

        const bundlesResult = userBundles.concat(newUserBundles)

        apiCalls.current = false
        setUserBundles(bundlesResult)
      } else {
        apiCalls.current = false
        setUserBundles([])
        bundleError.current = true
        setIsLoading(false)
        throw Error('Data not found')
      }
    } catch (e) {
      apiCalls.current = false
      setIsLoading(false)
      setUserBundles([])
      bundleError.current = true
      console.error(e)
    }
  }

  const fetchMyPracticeData = async (dataParams, tab, isRemove) => {
    if (!tab) {
      return
    }
    if (typeof tab === 'number') {
      setUserCompletedClasses((state) =>
        state?.filter((i) => i.entryId !== tab)
      )
      tab = 'completed'
    } else {
      setIsLoading(true)
    }

    let directionValue = ''
    let sortingValue = ''
    let daysAgo = null
    let pageValue = null
    let resetData = false

    switch (tab) {
      case 'series':
        directionValue = null
        sortingValue = sortOption.current
        pageValue = seriesPage
        daysAgo = null
        break
      case 'completed':
        directionValue = dataParams.sorting
          ? dataParams.sorting
          : selectedOptions.sorting
        sortingValue = dataParams.selectedColumn
          ? dataParams.selectedColumn
          : selectedOptions.selectedColumn
        sortingValue =
          sortingValue === 'completedTitle' ? 'title' : sortingValue
        daysAgo = dataParams.days ? dataParams.days : days
        pageValue = page
        break
      case 'classes':
        directionValue = selectedClassesOptions.sorting
        sortingValue = selectedClassesOptions.selectedColumn
        pageValue = classesPage
        daysAgo = null
        break

      default:
        break
    }

    // Reset page number if sorting changes
    if (
      selectedOptions.sorting !== previousSelectedOptions.sorting ||
      selectedOptions.selectedColumn !==
        previousSelectedOptions.selectedColumn ||
      daysSelected.current !== previousDays
    ) {
      // if (
      //   selectedOptions.selectedColumn !==
      //   previousSelectedOptions.selectedColumn
      // ) {
      //   dataParams.page = 1
      // } else {
      //   dataParams.page = null
      // }

      selectedOptions.selectedColumn !==
        previousSelectedOptions.selectedColumn && setPage(1)

      if (daysSelected.current !== previousDays) {
        setPreviousDays(daysSelected.current)
      }

      dataParams.page = 1
      setPage(1)
      resetData = true
    }

    if (sortOption.current !== sortPreviousOption.current) {
      setSeriesPage(1)
      sortPreviousOption.current = sortOption.current
      resetData = true
    }

    if (
      selectedClassesOptions.sorting !==
        previousSelectedClassesOptions.sorting ||
      selectedClassesOptions.selectedColumn !==
        previousSelectedClassesOptions.selectedColumn
    ) {
      dataParams.page = 1
      setClassesPage(1)
      resetData = true
    }

    if (resetDataApi.current) {
      resetData = true
      setPage(1)
      setSeriesPage(1)
      setClassesPage(1)
      resetDataApi.current = false
    }
    if (isRemove) {
      dataParams.page = 1
      setSeriesPage(1)
      setClassesPage(1)
      setPage(1)
      resetData = true
    }
    const filters = { ...getRequestObject(props.filteredAttributes) }
    const params = {
      direction: directionValue ? directionValue : 'desc',
      sort: sortingValue ? sortingValue : 'date',
      page: dataParams.page ? dataParams.page : pageValue,
      per_page: dataParams.perPage ? dataParams.perPage : perPage,
      days_ago: dataParams.days ? dataParams.days : daysAgo,
      ...filters
    }

    try {
      const res = await axios.get(`/my_practice?tab=${tab}`, { params })
      if (res.status === 200) {
        switch (tab) {
          case 'completed':
            const newUserInfo = res.data
            const completedSummary = newUserInfo.summary
            setCompletedSummary(completedSummary)

            const resultCompleted = mapDataCompleted(
              newUserInfo.listing,
              ElapsedTimeSince
            )

            setUserCompletedClasses((state) =>
              state && !resetData
                ? state.concat(resultCompleted)
                : resultCompleted
            )
            break
          case 'classes':
            const newClassesInfo = res.data
            const result = mapDataClasses(newClassesInfo)
            const classesListings =
              userClasses.length > 0 && resetData === false
                ? userClasses.concat(result)
                : result

            totalClasses.current = res.data.numberOfClasses

            setUserClasses(classesListings)

            break
          case 'series':
            const newUserSeries = res.data.series
            const seriesResult =
              userSeries.length > 0 && !resetData
                ? userSeries.concat(newUserSeries)
                : newUserSeries

            totalSeries.current = res.data.numberOfSeries

            setUserSeries(seriesResult)

            break
          default:
            console.log('no data')
            break
        }
      } else {
        setIsLoading(false)
        setError(true)
        throw Error('Data not found')
      }
      setIsLoading(false)
    } catch (e) {
      console.error(e)
    }
  }

  const favoriteClassCallback = () => {
    if (currentTab === 'completed') {
      fetchMyPracticeData(selectedOptions, 'completed', true)
    } else if (currentTab === 'classes') {
      fetchMyPracticeData(selectedOptions, 'classes', true)
    }
  }

  const removeFromCompletedCallback = (entryId) => {
    if (currentTab === 'completed') {
      fetchMyPracticeData(selectedOptions, entryId, true)
    }
  }

  const favoriteSeriesCallback = () => {
    const params = { selectedColumn: sortOption, days: null, page: 1 }
    fetchMyPracticeData(params, 'series', true)
  }

  const completedFilter = (selected) => {
    daysSelected.current = selected
    setSelectedOptions({ ...selectedOptions })
  }

  useEffect(() => {
    window.history.pushState({}, null, `/my/practice?tab=${currentTab}`)
  }, [currentTab])

  const fetchSeries = () => {
    change_practice_tab_event('series')
    setCurrentTab('series')
    resetDataApi.current = true
    tabClicked.current = true
    sortOption.current = sortOption?.current
      ? sortOption.current
      : 'recentlyAdded'
    const params = { selectedColumn: sortOption, days: null, page: 1 }
    fetchMyPracticeData(params, 'series')
    props.clearAllFilters()
  }

  const fetchClasses = () => {
    change_practice_tab_event('classes')
    setCurrentTab('classes')
    resetDataApi.current = true
    tabClicked.current = true
    fetchMyPracticeData(selectedClassesOptions, 'classes')
    setPreviousSelectedClassesOptions(selectedClassesOptions)
    props.clearAllFilters()
  }

  const fetchCompletedClasses = () => {
    change_practice_tab_event('completed')
    setCurrentTab('completed')
    resetDataApi.current = true
    tabClicked.current = true
    fetchMyPracticeData(selectedOptions, 'completed')
    setPreviousSelectedOptions(selectedOptions)
    props.clearAllFilters()
  }

  useLayoutEffect(() => {
    copy.length > 1 && setIsOpenModal(true)
  }, [copy])

  //bundles works only with the useEffect because we need to validate if the user has bundles to show the tab
  useEffect(() => {
    getMyBundles('', 'bundle')
  }, [])

  useEffect(() => {
    ;(tabClicked.current === true ||
      selectedClassesOptions.sorting !==
        previousSelectedClassesOptions.sorting ||
      selectedClassesOptions.selectedColumn !==
        previousSelectedClassesOptions.selectedColumn) &&
      fetchMyPracticeData(selectedClassesOptions, 'classes')
    setPreviousSelectedClassesOptions(selectedClassesOptions)
  }, [selectedClassesOptions])

  useEffect(() => {
    setPreviousSelectedOptions(selectedOptions)
  }, [selectedOptions])

  useEffect(() => {
    if (currentTab === 'completed') {
      fetchMyPracticeData(selectedOptions, 'completed')
    } else if (currentTab === 'classes') {
      fetchMyPracticeData(selectedOptions, 'classes')
    }
  }, [selectedOptions])

  const handleOnPlaylistTabCick = () => {
    change_practice_tab_event('playlists')
    setCurrentTab('playlists')
  }

  return (
    <Box>
      <MyPracticeDetailsProvider
        selectedOptions={selectedOptions}
        setSelectedOptions={setSelectedOptions}
        sortOption={sortOption}
        selectedClassesOptions={selectedClassesOptions}
        setSelectedClassesOptions={setSelectedClassesOptions}
        setDays={setDays}
        days={days}
      >
        <MyPracticeBox>
          <Title>my practice</Title>
          <Subtitle>
            YOUR HISTORY, SAVED CLASSES, PROGRAMS AND PLAYLISTS
          </Subtitle>
        </MyPracticeBox>
        <Container
          background='white'
          minHeight='650px'
          p={['16px 0', '16px 0', '16px']}
          centerProps={{
            maxWidth: '1550px'
          }}
        >
          {error && <NotFoundPage></NotFoundPage>}
          {apiCalls.current && <AloMovesAnimation />}
          {apiCalls.current === false && (
            <StyledTab id='my_practice_tabs'>
              <Tab
                id='1'
                title='Completed'
                style={{ flex: 1 }}
                fontSize={['13px', '13px', '16px', '16px']}
                active={currentTab === 'completed'}
                onClick={fetchCompletedClasses}
              >
                <CompletedClasses
                  fetchDataCompletedClasses={fetchMyPracticeData}
                  userCompletedClasses={userCompletedClasses}
                  summary={completedSummary}
                  loading={isLoading}
                  filterOption={completedFilter}
                  setPerPage={setPerPage}
                  perPage={perPage}
                  setPage={setPage}
                  favoriteCallback={favoriteClassCallback}
                  removeFromCompletedCallback={removeFromCompletedCallback}
                  page={page}
                  withSubcategories={props.withSubcategories}
                  includeFilters={props.includeFilters}
                  preloadedFilters={props.preloadedFilters}
                  baseUrl={props.baseUrl}
                  dropdownOptions={props.dropdownOptions}
                  currentTab={currentTab}
                  setUserCompletedClasses={setUserCompletedClasses}
                  showDurationSort={showDurationSort}
                />
              </Tab>

              <Tab
                id='2'
                title='Classes'
                style={{
                  flex: 1
                }}
                active={currentTab === 'classes'}
                onClick={fetchClasses}
              >
                {/* {isLoading && <AloMovesAnimation />} */}

                {/* {!isLoading && userClasses.length === 0 && (
                  <MyPracticeNotData option={'classes'} />
                )} */}
                {/* {!isLoading &&
                  // userClasses.length > 0 &&
                  ( */}
                <ClassesComponent
                  userClasses={userClasses}
                  fetchDataClasses={fetchMyPracticeData}
                  setPerPage={setPerPageClasses}
                  perPage={perPageClasses}
                  setPage={setClassesPage}
                  page={classesPage}
                  totalClasses={totalClasses.current}
                  favoriteCallback={favoriteClassCallback}
                  withSubcategories={props.withSubcategories}
                  includeFilters={props.includeFilters}
                  preloadedFilters={props.preloadedFilters}
                  baseUrl={props.baseUrl}
                  dropdownOptions={props.dropdownOptions}
                  currentTab={currentTab}
                  loading={isLoading}
                  setUserClasses={setUserClasses}
                />
                {/* )} */}
              </Tab>
              <Tab
                id='3'
                title='Programs'
                style={{ flex: 1 }}
                active={currentTab === 'series'}
                onClick={fetchSeries}
              >
                <MySeries
                  MySeries={userSeries}
                  optionChange={seriesOptionChange}
                  isLoading={isLoading}
                  setPerPage={setPerPageSeries}
                  perPage={perPageSeries}
                  setPage={setSeriesPage}
                  page={seriesPage}
                  fetchSeries={fetchMyPracticeData}
                  totalSeries={totalSeries.current}
                  favoriteCallback={favoriteSeriesCallback}
                  withSubcategories={props.withSubcategories}
                  includeFilters={props.includeFilters}
                  preloadedFilters={props.preloadedFilters}
                  baseUrl={props.baseUrl}
                  dropdownOptions={props.dropdownOptions}
                  currentTab={currentTab}
                />
              </Tab>
              <Tab
                id='4'
                title={
                  userBundles.length > 0 && !bundleError.current
                    ? 'Bundles'
                    : ''
                }
                style={{ flex: 1 }}
                active={currentTab === 'bundles'}
              >
                <Bundles
                  userBundles={userBundles}
                  isLoading={isLoading}
                  setPerPage={setPerPageBundles}
                  perPage={perPageBundles}
                  setPage={setBundlesPage}
                  page={bundlesPage}
                  fetchBundles={getMyBundles}
                  hasItems={hasItems}
                  totalBundles={totalBundles.current}
                />
              </Tab>
              <Tab
                id='5'
                title='Playlists'
                style={{ flex: 1 }}
                active={currentTab === 'playlists'}
                onClick={handleOnPlaylistTabCick}
              >
                <MyPlaylists currentTab={currentTab} />
              </Tab>
            </StyledTab>
          )}
        </Container>
        <Box>
          <PopUpModal
            id={'MyPracticeModal'}
            headerText={'Share class'}
            bodyText={url}
            leftButtonText={'Copy link'}
            rightButtonText={'Done'}
            isOpenModal={isOpenModal}
            setIsOpenModal={setIsOpenModal}
            leftButtonAction={copyToClipBoard}
            styles={popUpStyle}
            successAction={copy}
          ></PopUpModal>
        </Box>
      </MyPracticeDetailsProvider>
      <CoachmarkRenderer user={{ createdAt, username }} page='myPractice' />
    </Box>
  )
}

const mapStateToProps = (state) => {
  return {
    filteredAttributes: state.ui.planEntries.filtered,
    filterUrl: state.ui.planEntries.filterUrl
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearAllFilters: () => {
      dispatch(clearAllFilters())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(MyPractice)
